import { render, staticRenderFns } from "./SideBanner.vue?vue&type=template&id=3521ba05&"
import script from "./SideBanner.vue?vue&type=script&lang=js&"
export * from "./SideBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports